"use strict";

require("core-js/modules/esnext.weak-map.delete-all.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Icon = _interopRequireWildcard(require("./Icon"));
var _theme = _interopRequireDefault(require("../../theme"));
const _excluded = ["fill", "width", "height", "direction", "style"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// TODO: delete when this is no longer used

const IconDynamicArrow = _ref => {
  let {
      fill,
      width,
      height,
      direction,
      style
    } = _ref,
    others = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
  const rectPart = `M${width} 7L1 7L1 9L${width} 9L${width} 7`;
  const transform = direction === 'right' ? 'scale(-1, 1)' : null;
  return /*#__PURE__*/_react.default.createElement(_Icon.default, (0, _extends2.default)({
    width: width,
    height: height,
    style: Object.assign({}, style, {
      transform
    }),
    label: "Arrow"
  }, others), /*#__PURE__*/_react.default.createElement("path", {
    fill: fill,
    d: `M0.292893 7.29289C-0.0976315 7.68342 -0.0976314 8.31658 0.292893 8.70711L6.65686 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6569L2.41421 8L8.07107 2.34315C8.46159 1.95262 8.46159 1.31946 8.07107 0.928933C7.68054 0.538409 7.04738 0.538409 6.65685 0.928933L0.292893 7.29289Z${rectPart}Z`
  }));
};
IconDynamicArrow.defaultProps = {
  fill: _theme.default.colors.black,
  width: 16,
  height: 16,
  direction: 'left'
};
IconDynamicArrow.propTypes = Object.assign({
  fill: _propTypes.default.string,
  width: _propTypes.default.number,
  height: _propTypes.default.number,
  direction: _propTypes.default.oneOf(['left', 'right']),
  style: _propTypes.default.object,
  viewBox: _propTypes.default.string
}, _Icon.propTypes);
var _default = exports.default = IconDynamicArrow;